
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import TradingBotStats from "@/models/TradingBotStats";

/**
 * 📄 The possible bot statuses
 */
enum BotStatus {
  Active = "Active",
  SettingUp = "Setting Up",
  MarketScanFailed = "Market Scan Failed",
  PotentialIssues = "Potential Issues",
}

@Component
export default class TradingBotChipStatusIndicator extends Vue {
  @Prop()
  public botStats!: TradingBotStats;

  // 📦 The status of the selected bot
  private get botStatus(): BotStatus {
    const now = new Date().getTime() / 1000;
    const candleStickSizeInSeconds = this.getSecondsFromCandleStickSize(
      this.botStats.candles
    );

    if (this.botStats.last_trade_attempt == null) {
      return BotStatus.SettingUp;
    }

    if (this.botStats.last_trade_attempt < now - 4 * candleStickSizeInSeconds) {
      return BotStatus.MarketScanFailed;
    }

    if (
      this.botStats.last_trade_attempt >= now - 4 * candleStickSizeInSeconds &&
      this.botStats.last_trade_attempt <= now
    ) {
      return BotStatus.Active;
    }
    return BotStatus.PotentialIssues;
  }

  // 📦 The status image of the current bot
  private get statusImage(): string {
    switch (this.botStatus) {
      case BotStatus.Active:
        return require("@/assets/bot-chip/bot-chip-active-badge.svg");
      case BotStatus.SettingUp:
        return require("@/assets/bot-chip/bot-chip-setting-up-badge.svg");
      case BotStatus.MarketScanFailed:
        return require("@/assets/bot-chip/bot-chip-error-badge.svg");
      case BotStatus.PotentialIssues:
        return require("@/assets/bot-chip/bot-chip-warning-badge.svg");
    }
  }

  // 📦 The tooltip text that should be displayed when the user hovers
  private get tooltipStatusText(): string {
    switch (this.botStatus) {
      case BotStatus.Active:
        return "Actively trading & looking for new trading opportunities";
      case BotStatus.SettingUp:
        return "Setting up the bot (looking for the 1st trading opportunity)";
      case BotStatus.MarketScanFailed:
        return "Potential issues. Contact our support for further assistance";
      case BotStatus.PotentialIssues:
        return "Potential issues. Contact our support for further assistance";
    }
  }

  /**
   * 🔨 Parses the candlestick size and converts it to seconds
   */
  private getSecondsFromCandleStickSize(candleStickSize: string): number {
    const candlesSize: number = Number(candleStickSize.match(/\d+/)!![0]);
    const candlesUnit: string = candleStickSize.match(/[a-zA-Z]+/g)!![0];
    switch (candlesUnit) {
      case "h":
        return candlesSize * 3600;
      case "m":
        return candlesSize * 60;
      default:
        return -1;
    }
  }
}
